export * from './factory';
export * from './context';
export { default as MiddlemanContext } from './context';


import { getCurrentMiddleman } from './context';

// Legacy-compatible default export: live proxy bound to current context instance
const legacyMiddleman: any = new Proxy({}, {
  get(_target, prop: string | symbol) {
    const instance: any = getCurrentMiddleman();
    const value = (instance as any)[prop as any];
    return typeof value === 'function' ? value.bind(instance) : value;
  }
});

// Named helper to access CSRF via current context instance
export const csrf = () => getCurrentMiddleman().csrf();


export default legacyMiddleman;
